export const messengerAdsJSONHelpImage = '/assets/ads-json-help-new.png';
export const messengerAdsRefHelpImage = '/assets/ads-ref-help-new.png';
export const monkeyImage = '/assets/MobileMonkey.png';
export const monkeyImageWhite = '/assets/MobileMonkeyWhite.png';
export const permissionHelperImage = '/assets/permissions-helper.png';
